import * as React from 'react';
import { cn } from '@noor/lib/cn';

export type AppShellMainProps = React.ComponentProps<'main'>;

/**
 * The main content region to the right of the nav panels. A `flex-1 min-w-0`
 * column that provides the bounded, non-scrolling frame; compose a `PageShell`
 * (or any content) inside it to decide scroll behaviour within that box.
 */
function AppShellMain({ className, ...props }: AppShellMainProps) {
  return (
    <main
      data-slot="app-shell-main"
      className={cn('flex min-h-0 min-w-0 flex-1 flex-col', className)}
      {...props}
    />
  );
}

export { AppShellMain };
